import { StringKeys } from '@/resources/strings/StringKeys';
import { default as COLORS } from '@/resources/style/Themes';
import { PriorityHigh } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEmergencyActions } from '@/stores/map/emergencyStore';

const EmergencyListButton = () => {
  const emergencyActions = useEmergencyActions();

  return (
    <Box
      sx={{
        background: COLORS.RED,
        padding: '8px 16px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: COLORS.DARK_RED,
        },
      }}
      onClick={() => emergencyActions.setShowEmergencyListModal(true)}
    >
      <PriorityHigh style={{ color: COLORS.WHITE, marginRight: '8px' }} />
      <Typography variant="button" sx={{ color: 'white' }}>
        {t(StringKeys.VIEW_ACTIVE_EMERGENCIES)}
      </Typography>
    </Box>
  );
};

export default EmergencyListButton;
